export const CAMPAIGN_TYPE = {
  cyber: 'cyber',
  promotional: 'promotional',
  segment: 'segment',
};

const ICON_PROMOTIONAL_DEFAULT_PNG = 'https://imagescdn.rimac.com/blt3ea0dd753aa402f5/688d3b9574887d54cc46e197/icon-cintillo-default.png';
const ICON_PROMOTIONAL_DEFAULT_WEBP = 'https://imagescdn.rimac.com/blt041ea8136d75b0f7/688d3b95450d712524cebf4d/icon-cintillo-default.webp';

export const ICON_DEFAULT_PROPS_PNG = {
  image_desktop: {
    url: ICON_PROMOTIONAL_DEFAULT_PNG,
  },
  image_mobile: {
    url: ICON_PROMOTIONAL_DEFAULT_PNG,
  },
};

export const ICON_DEFAULT_PROPS_WEBP = {
  image_desktop: {
    url: ICON_PROMOTIONAL_DEFAULT_WEBP,
  },
  image_mobile: {
    url: ICON_PROMOTIONAL_DEFAULT_WEBP,
  },
};

export const validSubtypesRedirect = ['cyber_redirection', 'promotional_text_highlightRight_goButton', 'promotional_highlightLeft_text_goButton'];
